<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $t('testConnections') }}
          <v-btn color="primary" @click="download" :loading="loading_download" :disabled="loading_download"> {{ $t('download_xml_request') }} </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-form @submit.prevent="submit">
          <v-card class="mt-4">
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout wrap>

                  <v-flex xs12 md4>
                    <v-text-field 
                           :label="$t('upload_xml_request')" 
                           v-model="filename" 
                           @click="pickFile" 
                           prepend-icon="attach_file" 
                           v-validate="'required'"
                           :error-messages="errors.collect('upload_xml_request')"
                           data-vv-name="upload_xml_request"
                           :data-vv-as="$t('upload_xml_request')"
                           required
                    ></v-text-field>
                    <input type="file" style="display: none" ref="file" accept=".xml" @change="onFilePicked">
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="back" :loading="loading" :disabled="loading">{{ $t('cancel') }}</v-btn>
              <v-btn color="primary" dark :loading="loading" :disabled="loading" type="submit">{{ $t('send') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Carrier from '@/client/carrier'
export default {

  props: {},

  data () {
    return {
      filename: '',
      loading: false,
      loading_download: false,
      inputFile: ''
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    onFilePicked (e) {
      this.errors.clear()
      this.inputFile = e.target.files[0]
      this.filename = this.inputFile.name
    },

    pickFile () {
      this.$refs.file.click()
    },

    async download () {
      this.loading_download = true
      const data = await Carrier.downloadXML( this.carrierId() )
      this.setDownload(data, 'carrier_shipment.xml')
      this.loading_download = false
    },

    async submit () {
      try {
        const isValid = await this.$validator.validateAll()
        if (!isValid) { return }
        
        this.loading = true
        const formData = new FormData()
        formData.append('files[]', this.inputFile)
        
        const data = await Carrier.uploadShipmentXML( formData, this.carrierId() )
        this.loading = false
        this.setNotification({
          color: 'success',
          message: this.$t('SuccessfullySentRequest')
        })
        
        this.setDownload(data, 'carrier_shipment_response.xml')

        const pdfData = await Carrier.downloadLabelPdf( this.carrierId() )
        if(pdfData.size > 0) this.setDownload(pdfData, 'shipment_label_pdf.pdf')
      } catch (err) {
        this.handleErr(err)
      }
    },

    setDownload (data, fileName) {
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    carrierId () {
      return this.$route.params.carrier_id
    }
  },

  watch: {
  },

  async mounted () {
  }
}
</script>